module.exports = __webpack_public_path__ + "img/course.83bb2f72.svg";